import { LoadingButton } from "@mui/lab";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createDocumentation } from "utils/action";
import * as Yup from "yup";

// REDUX
import {
    InputFile,
    InputText,
    InputTextArea,
    setTitleCase,
} from "app/components/template/partials";
import { getUsers } from "app/redux/dropdown";
import { useDispatch } from "react-redux";

// form field validation schema
const initialValues = {
    title: "",
    content: "",
};

const validationSchema = Yup.object().shape({
    title: Yup.string().required("Judul wajib diisi!"),
    // photo: Yup.mixed()
    //   .test("is-valid-type", "Tipe gambar tidak sesuai!", (value) =>
    //     isValidFileType(value && value.name.toLowerCase(), "image")
    //   )
    //   .test(
    //     "is-valid-size",
    //     "Maksimum ukuran file adalah 5MB",
    //     (value) => value && value.size <= MAX_FILE_SIZE
    //   ),
});

export function CreateDocumentation() {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(false);
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const showDialog = location.state?.showDialog ?? false;
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        dispatch(getUsers());
    }, [dispatch]);

    const onHide = () => {
        navigate("/documentation");
    };

    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const handleUploadPhoto = (event) => {
        const file = event.target.files[0];
        setSelectedPhoto(file);
    };

    const handleFormSubmit = async (values) => {
        setLoading(true);
        const formData = new FormData();
        formData.append("photo", selectedPhoto);
        formData.append("title", values.title);
        formData.append("content", values.content);

        try {
            await createDocumentation(formData);
            toast.success(setTitleCase("berhasil menambahkan dokumentasi"));
        } catch (error) {
            toast.error(setTitleCase(error.response.data?.message));
        }
        setLoading(false);
        onHide();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={showDialog}
            onClose={onHide}
            aria-labelledby="responsive-dialog-create-documentation-title"
        >
            <DialogTitle id="responsive-dialog-create-documentation-title">
                Buat Dokumentasi
            </DialogTitle>
            <Divider />
            <Formik
                enableReinitialize
                onSubmit={handleFormSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent className="dialog-container">
                            <Grid container spacing={3}>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputText}
                                        name="title"
                                        label="Judul Dokumentasi"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputTextArea}
                                        minRows={3} // Ubah sesuai kebutuhan
                                        maxRows={10} // Ubah sesuai kebutuhan
                                        name="content"
                                        label="Konten Dokumentasi"
                                        variant="outlined"
                                        type="text"
                                        className="custom-textarea" // Tambahkan className
                                    />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                    <Field
                                        component={InputFile}
                                        name="photo"
                                        labelButton="Unggah Gambar"
                                        selectedPhoto={selectedPhoto}
                                        onChange={handleUploadPhoto}
                                    />
                                </Grid>
                                {selectedPhoto && (
                                    <Grid item md={12} xs={12}>
                                        <div>
                                            Foto yang dipilih:{" "}
                                            {selectedPhoto.name}
                                        </div>
                                        <img
                                            src={URL.createObjectURL(
                                                selectedPhoto
                                            )}
                                            alt={selectedPhoto.name}
                                            style={{
                                                maxWidth: "250px",
                                                maxHeight: "250px",
                                            }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <LoadingButton
                                autoFocus
                                loading={isLoading}
                                type="submit"
                                color="primary"
                                variant="contained"
                                disabled={selectedPhoto === null}
                            >
                                Simpan
                            </LoadingButton>

                            <Button
                                autoFocus
                                onClick={onHide}
                                color="error"
                                variant="contained"
                            >
                                Batal
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
}
